import { v4 as uuidv4 } from "uuid";
export class TagSaveModel {
    constructor() {
        this.id = uuidv4();
        this.name = "";
        this.tagDescription = "";
    }
}
export default class TagSave extends TagSaveModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
